import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/warehouse/requisition/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/warehouse/requisition/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/warehouseRequisition/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/warehouseRequisition/submit', params,options);

export const update = (params, options) =>
request.post('/api/warehouseRequisition/submit', params,options);


export const getUserlist = (params, options) =>
request.get('/api/v4ward/user/userList', Object.assign({}, options, { params }));

// 获取单号

export const getBusinessNo = (params, options) =>
request.get('/api/v4ward/warehouse/common/getBusinessNo', Object.assign({}, options, { params }));

// 获取申请金额
export const getPriceSum = (params, options) =>
request.get('/api/v4ward/warehouse/requisition/getPriceSum', Object.assign({}, options, { params }));

// 审核 3：通过 4驳回
export const aduit = (params, options) =>
request.post('/api/v4ward/warehouse/requisition/audit', params,options);
// 申请
export const applyFor = (params, options) =>
request.post('/api/v4ward/warehouse/requisition/save', params,options);

// 查询单价接口

// 获取申请金额
export const viewUpdateConsumableList = (params, options) =>
request.post('/api/v4ward/warehouse/consumable/viewUpdateConsumableList', params,options);

// 申请获取仓库下拉列表 /v4ward/warehouse/getWarehouseListApply 带权限
export const getWarehouseListApply = (params, options) =>
request.get('/api/v4ward/warehouse/getWarehouseListApply', Object.assign({}, options, { params }));

// 申请获取仓库下拉列表 /v4ward/warehouse/getWarehouseListApply 不带权限
export const getAllWarehouseListApply = (params, options) =>
request.get('/api/v4ward/warehouse/getAllWarehouseList', Object.assign({}, options, { params }));
// 根据领用单id获取明细货品
export const getDegetConsumableListByRequisitionIdtail = (params, options) =>
request.get('/api/v4ward/warehouse/requisition/consumable/getConsumableListByRequisitionId', Object.assign({}, options, { params }));



// 通过当前登录人获取科室
export const treeDeptsByIds = (params, options) =>
request.get('/api/v4ward/dept/listByUser', Object.assign({}, options, { params }));



// 根据部门id获取该部门下所有的用户
export const deptUserlist = (params, options) =>
request.get('/api/v4ward/user/getDeptUserListByDeptId', Object.assign({}, options, { params }));
